var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        centerScreen: "",
        bus: _vm.busModal,
        persistent: "",
        centerAndDecreasesPadding: "",
        maxWidth: "55%",
        closeColor: "#8e8e8e",
        backgroundColor: "white"
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: {
                    primary: "",
                    loading: _vm.loading,
                    disabled: !_vm.aceito || _vm.loading
                  },
                  on: { click: _vm.aceitar }
                },
                [_vm._v(" Aceitar e Continuar ")]
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "pb-6" }, [
        _c("div", { staticClass: "modal-title-container" }, [
          _c("span", { staticClass: "modal-title" }, [_vm._v("Termos de Uso")])
        ]),
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _vm.loadingTermos
              ? _c(
                  "div",
                  { staticClass: "d-flex justify-center align-center py-8" },
                  [
                    _c("v-progress-circular", {
                      attrs: { indeterminate: "", color: "primary" }
                    })
                  ],
                  1
                )
              : _vm.termos
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-center justify-space-between mb-3"
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "az-text-primary az-size-14" },
                        [_vm._v(" " + _vm._s(_vm.termos.titulo) + " ")]
                      ),
                      _c(
                        "span",
                        { staticClass: "az-text-primary az-size-12 az-muted" },
                        [_vm._v(" Versão " + _vm._s(_vm.termos.versao) + " ")]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "termos-container pa-4 rounded" },
                    _vm._l(_vm.termos.secoes, function(secao, idx) {
                      return _c("div", { key: idx, staticClass: "mb-4" }, [
                        _c(
                          "div",
                          { staticClass: "az-text-primary az-size-14 mb-1" },
                          [_vm._v(" " + _vm._s(secao.titulo) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "az-text-primary az-size-14 az-muted"
                          },
                          [_vm._v(" " + _vm._s(secao.conteudo) + " ")]
                        )
                      ])
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c("v-checkbox", {
                        staticClass: "mt-0",
                        attrs: { "hide-details": "" },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function() {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "az-text-primary az-size-14" },
                                  [
                                    _vm._v(" Li e concordo com os "),
                                    _c("strong", [_vm._v("Termos de Uso")]),
                                    _vm._v(" do módulo de Mensagens WhatsApp ")
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ]),
                        model: {
                          value: _vm.aceito,
                          callback: function($$v) {
                            _vm.aceito = $$v
                          },
                          expression: "aceito"
                        }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e()
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }